import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonService } from '../services/common.service';
import { Authorization } from '../models/data.model';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public accountService: CommonService<Account>, public router: Router) {
    //console.log("accountService", accountService);
    //console.log("router", router);
    //this.ImLogged();
  }
  private appoggioLink: string; 
  private loggedIn:boolean;
  private profile:any;
  private static mail;
  private idutente: string;
  private idallegato: string;

  isLoggedIn():boolean{
    return this.loggedIn;
  }
  setLoggedIn = (val)=>{
      this.loggedIn = val;
  }

  getProfile=()=>{
    return this.profile;
  }
  setProfile=(profile)=>{
    this.profile = profile;
  }

  RecuperaParametri(id) {
    if (id != undefined && id.includes('?')) {
      let recuperaParametri = id

      id = recuperaParametri.split('?')[0]
      recuperaParametri = recuperaParametri.split('?')[1]
      recuperaParametri = recuperaParametri.split('&')
      this.idutente = recuperaParametri[0].split('=')[1]
      this.idallegato = recuperaParametri[1].split('=')[1]

    } else {
      this.idutente = '';
    
    }
    return id
  }

  ImLogged = (id,app) => {
    
    id = this.RecuperaParametri(id)
    return new Promise((resolve, reject) => {
      
      const BASE_URL = "api/auth/isUserLogged";
      this.accountService.getData(BASE_URL, {}, false).subscribe(result => {

        this.setLoggedIn(true);
        this.setProfile(result);
        resolve(result);        
          console.log('Login check result',result);
      },
      error => {
        console.log('NO' + error)
        if (error.status == 401) // unauthorized.
        {
           this.setLoggedIn(false);
           this.redirectToLogin("openIdLogin");
          reject(error);
          // if (id == undefined) {
          //   this.redirectToLogin("openIdLogin");

          // } else {
          //   if (this.idutente != '') {
          //     this.router.navigate(['/openIdLogin', id],
          //       { queryParams: { idutente: this.idutente, idallegato: this.idallegato } });
          //   } else {
          //     if (app != 'openIdLogin') {
          //       id = app + "-" + id
          //       this.router.navigate(['/openIdLogin', id]);
          //     }
          //   }
          //   //this.redirectToLogin("login/" + id); // Evolutive Maggio Giugno Luglio 2021: Cliccando sul link della notifica si arriva al direttamente al dettaglio del documento.
          // }
        }
      });
    });
  }

  redirectToLogin = (state) => {
    this.router.navigate(['/' + state] );
  }

  canActivate() {
    if (!this.ImLogged(undefined, undefined)) {
      this.router.navigate(['openIdLogin']);
      return false;
    }
    return true;
  }
}

